import { memo } from 'react';
import { Label } from 'semantic-ui-react';
import { ImportDescriptorIdType } from '../../../../../../types';
import {
    useImportTableStoreIsDescriptorDataTypeNumber,
    useImportTableStoreReportActions,
} from '../../../../context/importTableContext';

type SingFlipCellPropsType = {
    descriptorId: ImportDescriptorIdType;
};
const SingFlipCell = memo(function SingFlipCell({ descriptorId }: SingFlipCellPropsType) {
    const isDescriptorDataTypeNumber = useImportTableStoreIsDescriptorDataTypeNumber(descriptorId);
    const { inverseReportsFieldValues } = useImportTableStoreReportActions();
    return (
        <td>
            {isDescriptorDataTypeNumber && (
                <Label
                    className="import-table__label cursor-pointer"
                    onClick={() => inverseReportsFieldValues(descriptorId)}
                    size="mini"
                >
                    FLIP
                </Label>
            )}
        </td>
    );
});

export default SingFlipCell;
